import { IcoPencil16 } from '@onefootprint/icons';
import { Popover } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import type { RefObject } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { AgentIconKind } from './agent-icons';
import AGENT_ICONS, { AGENT_ICON_COMPONENTS } from './agent-icons';
type AgentIconPickerProps = {
  value: AgentIconKind;
  onChange?: (icon: AgentIconKind) => void;
  disabled?: boolean;
  portalContainerRef?: RefObject<HTMLElement | null>;
};
const AgentIconPicker = ({
  value,
  onChange,
  disabled,
  portalContainerRef
}: AgentIconPickerProps) => {
  const {
    t
  } = useTranslation('agents', {
    keyPrefix: 'agentBuilder.canvas.header.renameDialog.icon'
  });
  const [open, setOpen] = useState(false);
  const portalContainer = portalContainerRef?.current ?? null;
  const SelectedIcon = AGENT_ICON_COMPONENTS[value];
  const handleSelect = (icon: AgentIconKind) => {
    onChange?.(icon);
    setOpen(false);
  };
  return <Popover side="bottom" align="end" controlledOpen={open} onControlledOpenChange={setOpen} portalContainer={portalContainer} content={<div className="grid grid-cols-6 grid-rows-4 gap-x-2 gap-y-2 p-3 md:grid-cols-8 md:grid-rows-3 md:gap-x-4">
          {AGENT_ICONS.map(icon_0 => {
      const Icon = AGENT_ICON_COMPONENTS[icon_0];
      return <button key={icon_0} aria-label={t($ => $.select, {
        icon: icon_0
      })} type="button" onClick={() => handleSelect(icon_0)} className={cx('flex size-9 items-center justify-center overflow-hidden rounded cursor-pointer border-2', icon_0 === value ? 'border-secondary!' : 'border-transparent hover:border-tertiary')}>
                <Icon />
              </button>;
    })}
        </div>}>
      <button type="button" disabled={disabled} aria-label={t($_0 => $_0.choose)} className="group relative flex size-10 items-center justify-center overflow-hidden rounded bg-info cursor-pointer disabled:cursor-not-allowed disabled:opacity-50">
        <SelectedIcon />
        <div className="absolute inset-0 flex items-center justify-center bg-[#00000080] opacity-0 transition-opacity group-hover:opacity-100 group-disabled:hidden">
          <IcoPencil16 className="text-white" />
        </div>
      </button>
    </Popover>;
};
export default AgentIconPicker;